import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { SelectField, SelectFieldProps } from '../SelectField';
import { orderByLabel, useCreateSelectFieldOptions } from './utils';

export type EnumSelectFieldProps<T extends keyof Mews.EnumLocalization['prefixes']> = Omit<
    SelectFieldProps,
    'options'
> & {
    enumPrefix: T;
    enumClass: Mews.EnumLocalization['prefixes'][T]['classType'];
    disabledValues?: Array<Mews.EnumLocalization['prefixes'][T]['valueType']>;
    enabledValues?: Array<Mews.EnumLocalization['prefixes'][T]['valueType']>;
    hintModifier?: string;
    omitHint?: boolean;
};

export const EnumSelectField = <T extends keyof Mews.EnumLocalization['prefixes']>({
    enumClass,
    enumPrefix,
    enabledValues = [],
    disabledValues = [],
    omitHint = false,
    hintModifier,
    ...props
}: EnumSelectFieldProps<T>) => {
    const selectFieldOptions = pipe(
        enumClass,
        Object.values,
        useCreateSelectFieldOptions(enabledValues, disabledValues, enumPrefix, omitHint, hintModifier),
        array.sort(orderByLabel)
    );
    return <SelectField {...props} options={selectFieldOptions} />;
};
